import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function BeforeAfterSection() {
  return <section className="w-full bg-cream py-16 px-4 flex flex-col items-center" data-id="element-3">
      <div className="max-w-3xl w-full" data-id="element-4">
        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border-2 border-gold-400 text-center relative overflow-hidden" data-id="element-5">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-gold-400 to-gold-500" data-id="element-6"></div>

          <div className="flex justify-center mb-6" data-id="element-7">
            <div className="bg-gold-100 p-4 rounded-full" data-id="element-8">
              <ShieldCheck className="text-gold-500" size={64} data-id="element-9" />
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-brown-800 mb-6" data-id="element-10">
            🛡️ GARANTÍA FREEZER INTELIGENTE — 7 DÍAS
          </h2>

          <p className="text-xl md:text-2xl text-brown-600 font-medium" data-id="element-11">
            Si sentís que no es para vos, te devolvemos el dinero. Sin vueltas.
          </p>
        </div>
      </div>
    </section>;
}